import React, { useEffect } from 'react';
import {
  useAnalyticsContext,
  NoflakeTag,
} from '@narvar/nth-hook-context-analytics';
import { useCustomComponentStateContext } from '../hooks/useCustomComponentState';
import useIsMLProductRecsOn from '../hooks/useIsMLProductRecsOn';
import useReportProductRecsKind from '../hooks/useReportProductRecsKind';
import Script from './Script';
import Json from './Json';

function App() {
  const { state } = useCustomComponentStateContext();
  const { update } = useAnalyticsContext();

  const mlProductRecsEnabled = useIsMLProductRecsOn('track-npr');
  useReportProductRecsKind({ mlProductRecsEnabled });

  useEffect(() => {
    if (!state) return;

    const { pageContext } = state;

    if (!pageContext) return;

    const {
      carrier,
      trackingNumbers,
      trackingStatus,
      orderNumbers,
      localeLanguage,
      localeCountry,
      retailerMoniker,
      trackingType,
      versionName,
      product,
      segmentId,
      segmentName,
    } = pageContext;

    update({
      // NOTE: This will always be provided by webpack, so defaulting to an
      // empty string for static analysis / testing.
      noflakeUrl: process.env.NOFLAKE_URL ?? '',
      errorCallback: (err) => {
        // TODO: Do proper error reporting
        // eslint-disable-next-line no-console
        console.log(err);
      },
      data: {
        eventCarrierMoniker: carrier,
        eventSchema: NoflakeTag.COMPONENT_PLATFORM,
        eventTrackingNumber: trackingNumbers?.[0],
        eventTrackStatus: trackingStatus,
        orderNumber: orderNumbers?.[0],
        pageLocaleCountry: localeCountry,
        pageLocaleLanguage: localeLanguage,
        pageOrderNumber: orderNumbers?.[0],
        pageRetailerMoniker: retailerMoniker,
        pageShipmentStatus: trackingStatus,
        pageTrackType: trackingType,
        pageUrlLocale:
          localeLanguage &&
          localeCountry &&
          `${localeLanguage}_${localeCountry}`,
        pageVersionName: versionName,
        productName: product,
        segmentId,
        segmentName,
        tag: NoflakeTag.COMPONENT_PLATFORM,
      },
    });
  }, [state, update]);

  return (
    <>
      <Script />
      <Json />
    </>
  );
}

export default App;
